import { useState } from "react";
import { useT } from "../i18n";

export interface BookingFormData {
  name: string;
  email: string;
  phone: string;
  notes: string;
}

const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

export function BookingForm({
  submitting,
  onSubmit,
  onBack,
}: {
  submitting: boolean;
  onSubmit: (data: BookingFormData) => void;
  onBack: () => void;
}) {
  const { t } = useT();
  const [data, setData] = useState<BookingFormData>({
    name: "",
    email: "",
    phone: "",
    notes: "",
  });
  const [errors, setErrors] = useState<{ name?: string; email?: string }>({});

  const set = (k: keyof BookingFormData) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
    setData({ ...data, [k]: e.target.value });

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const errs: typeof errors = {};
    if (data.name.trim().length < 2) errs.name = t("required");
    if (!EMAIL_RE.test(data.email)) errs.email = data.email ? t("invalidEmail") : t("required");
    setErrors(errs);
    if (Object.keys(errs).length === 0) onSubmit(data);
  };

  return (
    <form className="form" onSubmit={submit}>
      <div className="section-label">{t("yourDetails")}</div>
      <label>
        {t("name")}
        <input value={data.name} onChange={set("name")} />
        {errors.name && <span className="err">{errors.name}</span>}
      </label>
      <label>
        {t("email")}
        <input type="email" value={data.email} onChange={set("email")} />
        {errors.email && <span className="err">{errors.email}</span>}
      </label>
      <label>
        {t("phone")}
        <input value={data.phone} onChange={set("phone")} />
      </label>
      <label>
        {t("notes")}
        <textarea value={data.notes} onChange={set("notes")} rows={3} />
      </label>
      <div className="row">
        <button type="button" className="btn ghost" onClick={onBack} disabled={submitting}>
          {t("back")}
        </button>
        <button type="submit" className="btn primary" disabled={submitting}>
          {submitting ? t("booking") : t("confirmBooking")}
        </button>
      </div>
    </form>
  );
}
